import React, { useState, useEffect, useRef } from 'react';

import { reqGET, repo_img_link, content_language, translate } from '../../../../Utils';

import * as Hosts from "../../../../Hosts";

import { language } from '../Language';

//import parse from 'html-react-parser';

import { Navigation, Pagination, Autoplay, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import "swiper/swiper-bundle.min.css";

import AssecImage from "../../ASSEC_Image/Image"

import Loader from '../../../../loader';
// import "../../Pagina.css";
import "./HomeTeam_02.css"

const HomeTeam = (props) => {

	const [, set_dados] = useState(null)
	const team_list = useRef([])
	const dados_config = useRef([])

    const [team_title, set_team_title] = useState('')
    const [team_subtitle, set_team_subtitle] = useState('')

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [lang_id, set_lang_id] = useState('1');

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            
            for (let el of dados_config.current.content[0].components) {

                if(el.info.tag === 'team' && el.info.active) {
                    set_team_title(translate(el.info.title, lang))
                    set_team_subtitle(translate(el.info.subtitle, lang))
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        const getTeam = async () => {
            reqGET(`${Hosts.SIMCore_API}/web/content/type/${Hosts.companycode}/team`)
                .then(res => {

                    set_dados(team_list.current = res.data)
                    setLoading(false)

                }).catch(erro => console.log('Erro1', erro))
        }
        getTeam()

    }, [props, lang])

    function get_image_content(el, type) {
  
        let result = ''
  
        if(parseInt(lang_id) !== 1 && el.content[0]['language'] !== undefined && el.content[0]['language'][lang_id] !== undefined && el.content[0]['language'][lang_id] !== null && el.content[0]['language'][lang_id]['media'] !== null && el.content[0]['language'][lang_id]['media']['image'] !== undefined && el.content[0].language[lang_id]['media']['image'].length > 0) { 
          if(type === 'name') {
            result = el.content[0].language[lang_id].media.image[0].name
          }
          else if(type === 'url') {
            result = el.content[0].language[lang_id].media.image[0].url
          }
          else if(type === 'link') {
            result = el.content[0].language[lang_id].media.image[0].link
          }
        } else {
          if(el.content[0].media.image !== undefined && el.content[0].media.image !== null && el.content[0].media.image.length > 0) {
  
            if(type === 'name') {
              result = el.content[0].media.image[0].name
            }
            else if(type === 'url') {
              result = el.content[0].media.image[0].url
            }
            else if(type === 'link') {
              result = el.content[0].media.image[0].link
            }
    
          }
  
        }
  
      return result
    }

    return (
        isloading ?
            <Loader />
		:

            <section id="hometeam_02">
                <div className="container">
                    <div className="row">
                        <div className="col-12 title-properties">
                            <h3 className="titulo-pp">
                                {team_title}
                            </h3>
                            {
                                team_subtitle !== '' ?
                                    <h4 className={"subtitulo-pp"}>
                                    {team_subtitle}
                                    </h4>
                                :
                                null
                            }
                            <hr></hr>
                        </div>
                        <div className="col-12 text-end mb-3">
                            <a className="btn btn-expand" href={'./team/all'} >
                                <span>{language[lang].see_all}</span>
                                <i className="bi bi-arrow-right"></i>
                            </a>
                        </div>
                        
                        <div className="col-12">
                            {
                            team_list.current !== undefined && team_list.current !== null && team_list.current.length > 0 ?
                                <div className="swiper-container swiper-team">
                                    <Swiper className="p-1" modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
                                        speed={500}
                                        loop={false}
                                        autoHeight={false}
                                        autoplay={{
                                        delay: 5000,
                                        disableOnInteraction: false,
                                        }}
                                        spaceBetween={15}
                                        slidesPerView={2}
                                    //navigation
                                        pagination={{
                                        el: '.swiper-pagination-team',
                                        clickable: true
                                        }}
                                    //scrollbar={{ draggable: true }}
                                    breakpoints={{
                                        // when window width is >= 0px
                                        0: {
                                        slidesPerView: 2,
                                        //slidesPerGroup: 2
                                        },
                                        // when window width is >= 768px
                                        768: {
                                        slidesPerView: 3,
                                        //lidesPerGroup: 3
                                        },
                                        992: {
                                        slidesPerView: 3,
                                        //lidesPerGroup: 3
                                        },
                                        1200: {
                                        slidesPerView: 4,
                                        //slidesPerGroup: 4
                                        },
                                    }}
                                    >
                                        {
                                        team_list.current.map((v, k) => {
                                            if(k < 9) {
                                                return (
                                                    <SwiperSlide key={k}>
                                                        <a href={'./team/' + v.id} title={language[lang].learn_more + ' - ' + (lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title))}>
                                                            <div className="card">
                                                                <div className="card-img-top">
                                                                    <AssecImage
                                                                        linkImage={get_image_content(v, 'link') !== '' ? get_image_content(v, 'link') : repo_img_link('nophoto.webp')}
                                                                        width="400"
                                                                        height="450"
                                                                        fit='crop'
                                                                        type='img'
                                                                        sClass='img-fluid'
                                                                        loading="lazy"
                                                                        alt={get_image_content(v, 'name').includes('webp') || get_image_content(v, 'name').includes('jpg') || get_image_content(v, 'name').includes('png') || get_image_content(v, 'name') === '' ? 'team-image' : get_image_content(v, 'name') + ' (team-image)'}
                                                                        title={lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}
                                                                    />
                                                                </div>
                                                                <div className="card-body">
                                                                    <div className="team-title">
                                                                        {lang === 'pt' || v.content[0].language === undefined ? v.content[0].title : (v.content[0].language[lang_id] === undefined || v.content[0].language[lang_id].title === undefined || v.content[0].language[lang_id].title === '' ? v.content[0].title : v.content[0].language[lang_id].title)}  
                                                                    </div>
                                                                    {
                                                                        v.content?.[0]?.contacts?.specialty && (
                                                                            <div className="team-speciality small">
                                                                                {v.content?.[0]?.contacts.specialty}  
                                                                            </div>
                                                                        )
                                                                    }
                                                                    {
                                                                        /*v.content?.[0]?.contacts?.ballot && (
                                                                            <div className="team-ballot">
                                                                                {v.content?.[0]?.contacts.ballot}  
                                                                            </div>
                                                                        )*/
                                                                    }
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </SwiperSlide>
                                                )
                                            } else {
                                                return null
                                            }
                                        })
                                        }
                                    </Swiper>
                                    <div className="swiper-pagination-team mt-4"></div>
                                </div>
                            :
                                null
                            }
                        </div>
                    
                    </div>
                </div>
            </section>
    )
};
export default HomeTeam;